import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import './App.css';
import 'bootstrap';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <Router>
    <Fragment>
      <App />
    </Fragment>
  </Router>,
  document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js